import { render, staticRenderFns } from "./UserNavbarMenu.vue?vue&type=template&id=faa1b33e&"
import script from "./UserNavbarMenu.vue?vue&type=script&lang=js&"
export * from "./UserNavbarMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseAvatarImage: require('/d3_frontend/base-tailwindcss-components/src/AvatarImage.vue').default})
